import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { useAppSelector } from '@/hooks/useAppSelector';
import { Form, handleFormSubmit } from '@/modules/forms';
import { Loader } from '@/modules/ui';

import { settingsFormSchema, type SettingsFormSchemaType, type SettingsFormValues } from '../../schemas';
import { updateSettings } from '../../services/actions';
import { selectSettingsApi, selectSettingsFormInitialValues } from '../../services/selectors';

export interface SettingsFormProviderProps {
    children: ReactNode;
}

export const SettingsFormProvider = ({ children }: SettingsFormProviderProps) => {
    const intl = useIntl();
    const dispatch = useDispatch();

    const api = useAppSelector(selectSettingsApi);
    const defaultValues = useAppSelector(selectSettingsFormInitialValues);

    if (api.inProgress) {
        return <Loader />;
    }

    return (
        <Form<SettingsFormSchemaType, SettingsFormValues>
            schema={settingsFormSchema}
            defaultValues={defaultValues}
            onSubmit={handleFormSubmit((values, actions) => dispatch(updateSettings(values, actions)))}
            aria-label={intl.formatMessage({
                id: 'settings.form.title',
            })}
        >
            {children}
        </Form>
    );
};
